const pipelineStepStatuses = {
	DISABLED: "disabled",
	PENDING: "pending",
	RUNNING: "running",
	COMPLETED: "completed",
	FAILED: "failed",
};

export default pipelineStepStatuses;
